import { z } from 'zod';

/**
 * Validates the subset of Vite env vars the client depends on. Vite only
 * exposes variables prefixed with VITE_. Fails loudly at startup if misconfigured.
 */
const envSchema = z.object({
  // Base URL for the API. Empty string means "same origin" (dev proxy / prod
  // behind the same domain), which is the default.
  VITE_API_URL: z.string().default(''),
});

const parsed = envSchema.safeParse(import.meta.env);

if (!parsed.success) {
  const issues = parsed.error.issues
    .map((issue) => `  - ${issue.path.join('.')}: ${issue.message}`)
    .join('\n');
  throw new Error(`Invalid client environment configuration:\n${issues}`);
}

export const env = {
  apiUrl: parsed.data.VITE_API_URL,
  isDev: import.meta.env.DEV,
  isProd: import.meta.env.PROD,
} as const;
